module.exports = {
  currency: {
    MATIC: "matic",
    HBAR: "hbar",
    NEAR: "near",
    SIKI: "siki"
  }
}
